import React, { useState, useRef } from 'react';
import CreateNewList from '../CreateNewList';
import FavoriteButton from '../../shared/FavoriteButton';
import Modal from '../../shared/Modal';
import styles from './styles/styles.module.scss';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const renderTableRows = (saveToList, listHashOwner, handleFavoriteClick) => {
  const my = true;
  const tableRows = listHashOwner.state.myLists
    .sort((a, b) => b.order - a.order)
    .map(list => {
      const listId = list.id;
      // Array of strings showing what the list contains (e.g. 1 Trail, 3 Recordings)
      const contains = [];
      ['trail', 'map', 'track'].forEach(type => {
        const num = Object.keys(listHashOwner.itemsInListOfType(my, listId, type)).length;
        if (num > 1) {
          const typeMultiple = StringConstantsMixin.strings.LIST_MODAL.TYPE_MULTIPLE[type.toUpperCase()];
          contains.push(`${num} ${typeMultiple}`);
        } else if (num > 0) {
          const typeSingle = StringConstantsMixin.strings.LIST_MODAL.TYPE_SINGLE[type.toUpperCase()];
          contains.push(`${num} ${typeSingle}`);
        }
      });
      const profilePhotoUrl = `/api/alltrails/lists/${listId}/profile_photo?key=3p0t5s6b5g4g0e8k3c1j3w7y5c3m4t8i&size=medium_square`;
      const isInList = listHashOwner.isItemInList(my, listId, saveToList.type, saveToList.objectId);
      const onClick = () => handleFavoriteClick(listId, saveToList.type, saveToList.objectId);
      return (
        <tr key={`list-${listId}`}>
          <td>
            <img src={profilePhotoUrl} />
          </td>
          <td>
            <div className={styles.name}>{list.title}</div>
            <div className={styles.contains}>{contains.join(' · ')}</div>
          </td>
          <td>
            <FavoriteButton onWhiteBg handleFavoriteClick={onClick} isFavorite={isInList} />
          </td>
        </tr>
      );
    });
  return tableRows;
};

export default function SaveToListModal({ saveToList, listHashOwner, handleFavoriteClick, handleClose }) {
  const [edit, setEdit] = useState(false);
  const tableRef = useRef();

  const handleListCreated = list => {
    if (listHashOwner) {
      listHashOwner.addList(list.list_id, list.title, list.order);
      // add item to new list
      if (saveToList) {
        const { type, objectId } = saveToList;
        listHashOwner.addListItem(null, list.list_id, type, objectId);
      }
    }
    setEdit(false);
  };

  return (
    <Modal handleBackgroundClick={handleClose}>
      <div className={styles['save-to-list-container']}>
        <button className="close" onClick={handleClose} type="button" label={StringConstantsMixin.strings.CLOSE} />
        <div className={styles.title}>{StringConstantsMixin.strings.LIST_MODAL.SAVE_TO_LIST}</div>
        <div ref={tableRef} className={styles['table-wrapper']}>
          <table>
            <tbody>{renderTableRows(saveToList, listHashOwner, handleFavoriteClick)}</tbody>
          </table>
        </div>
        <CreateNewList
          edit={edit}
          handleEditClick={() => setEdit(true)}
          handleCancelClick={() => setEdit(false)}
          handleListCreated={handleListCreated}
          tableRef={tableRef}
        />
      </div>
    </Modal>
  );
}
